import { CommonModule } from '@angular/common';
import {
    TgButtons2Module,
    TgFormsModule,
    TgGridModule,
    TgIconEmoHappyModule,
    TgIconEmoNeutralModule,
    TgIconEmoSadModule,
    TgModalModule,
    TgSpacingModule,
    TgToggleModule
} from '@trademe/tangram';
import { NgModule } from '@angular/core';
import { FeedbackModule } from '../feedback/feedback.module';
import { FeedbackEmailButtonComponent } from './feedback-email-button.component';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        TgModalModule,
        TgIconEmoHappyModule,
        TgIconEmoNeutralModule,
        TgIconEmoSadModule,
        TgFormsModule,
        TgSpacingModule,
        TgToggleModule,
        TgButtons2Module,
        FeedbackModule
    ],
    declarations: [
        FeedbackEmailButtonComponent
    ],
    exports: [FeedbackEmailButtonComponent]
})
export class FeedbackEmailButtonModule {
}
